import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ReviewCard from "./ReviewCard";

const reviews = [
  {
    name: "Sophia Carter",
    date: "2023-08-15",
    text: "FitTrack has completely changed my approach to fitness. The insights are amazing!",
    likes: 12,
    comments: 2,
    avatar: "https://i.pravatar.cc/150?img=32",
    rating: 5,
  },
  {
    name: "Ethan Bennett",
    date: "2023-09-22",
    text: "The tracking features help me make informed decisions. I love the UI too!",
    likes: 8,
    comments: 1,
    avatar: "https://i.pravatar.cc/150?img=56",
    rating: 4,
  },
  {
    name: "Olivia Hayes",
    date: "2023-10-10",
    text: "More than just a tracker – FitTrack is a supportive companion in my routine.",
    likes: 15,
    comments: 0,
    avatar: "https://i.pravatar.cc/150?img=12",
    rating: 5,
  },
  {
    name: "Liam Turner",
    date: "2024-01-05",
    text: "Excellent accuracy in tracking! Love the personalized suggestions.",
    likes: 20,
    comments: 3,
    avatar: "https://i.pravatar.cc/150?img=60",
    rating: 4,
  },
  {
    name: "Emma Johnson",
    date: "2024-02-10",
    text: "Amazing interface and intuitive features. Highly recommended.",
    likes: 10,
    comments: 0,
    avatar: "https://i.pravatar.cc/150?img=8",
    rating: 5,
  },
];

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6, ease: "easeOut" },
  }),
};

const ITEMS_PER_PAGE = 5;

export default function Testimonials() {
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const totalPages = Math.ceil(reviews.length / ITEMS_PER_PAGE);

  const paginatedReviews = reviews.slice(
    page * ITEMS_PER_PAGE,
    (page + 1) * ITEMS_PER_PAGE
  );

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 1000); 
    return () => clearTimeout(timer);
  }, [page]);

  return (
    <section className="bg-[#0e1a10] text-white px-6 py-12 font-manrope">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-green-400">
          What Our Users Say
        </h2>

        <div className="flex flex-col gap-6">
          {isLoading
            ? Array.from({ length: ITEMS_PER_PAGE }).map((_, i) => (
                <div key={i}>
                  <ReviewCard isLoading={true} />
                </div>
              ))
            : paginatedReviews.map((r, i) => (
                <motion.div
                  key={i}
                  variants={fadeInUp}
                  custom={i}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.2 }}
                >
                  <ReviewCard {...r} />
                </motion.div>
              ))}
        </div>

        {/* Pagination */}
        <div className="mt-8 flex justify-center gap-4">
          <button
            onClick={() => setPage((p) => Math.max(p - 1, 0))}
            disabled={page === 0 || isLoading}
            className="px-4 py-2 rounded bg-green-500 text-black hover:bg-green-400 transition disabled:opacity-50"
          >
            Previous
          </button>
          <button
            onClick={() => setPage((p) => Math.min(p + 1, totalPages - 1))}
            disabled={page === totalPages - 1 || isLoading}
            className="px-4 py-2 rounded bg-green-500 text-black hover:bg-green-400 transition disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </section>
  );
}
